import { isEmptyObject } from "@sky-it-livedata-libraries/livedata-commons";
import { LgpHeroQuery, LgpHeroSubscription } from "../types";

const isSubscription = (container: LgpHeroSubscription | LgpHeroQuery): container is LgpHeroSubscription =>
  container.data.hasOwnProperty('onUpdateLgpHeroWidgetBySeasonAndCompIdAndGpId');
export const getWidget = (container: LgpHeroSubscription | LgpHeroQuery) =>
  isSubscription(container)
    ? container.data.onUpdateLgpHeroWidgetBySeasonAndCompIdAndGpId
    : container.data.getLgpHeroWidget;

/**
 * typeguard for ILgpHeroQuery
 * @param LgpHero object passed to transformer
 */
export const isValidLgpHero = (LgpHero: LgpHeroSubscription | LgpHeroQuery): boolean =>
  LgpHero && LgpHero.data ? Boolean(getWidget(LgpHero) && !isEmptyObject(getWidget(LgpHero))) : false;
